import { toast } from "sonner";

export const fetchAddressByZipCode = async (zipCode: string) => {
  const cepValue = zipCode.replace(/\D/g, "");
  if (cepValue.length === 8) {
    try {
      const fetchedResponse = await fetch(
        `https://viacep.com.br/ws/${cepValue}/json/`
      );
      if (!fetchedResponse.ok) throw new Error("Erro ao buscar CEP");

      const response = await fetchedResponse.json();

      if (response?.erro) {
        toast.error("Falha ao buscar cep", {
          style: { backgroundColor: "red", color: "white" },
        });
      }

      return response;
    } catch {
      return null;
    }
  }

  toast.error("CEP incompleto", {
    style: { backgroundColor: "red", color: "white" },
  });
  return null;
};
